import { IntlMessages } from '../../../helper/langHelper';

export const unitList = [
  { id: 'Kg', label: 'Kg' },
  { id: 'Tonne', label: 'Tonne' },
  { id: 'Lt', label: 'Lt' },
  { id: 'Bail', label: 'Bail' },
  { id: 'Roll', label: 'Roll' },
  { id: 'Bushels', label: 'Bushels' },
];

export const ProductIntegrityDropdownValues = [
  { value: '0', label: <IntlMessages id="productIntegrityDropdownValues.one" /> },
  { value: '1', label: <IntlMessages id="productIntegrityDropdownValues.two" /> },
  { value: '2', label: <IntlMessages id="productIntegrityDropdownValues.three" /> },
  { value: '3', label: <IntlMessages id="productIntegrityDropdownValues.four" /> },
];
